<template>
  <div class="xkztck">
    <Header title="选课状态查看" type="0" route="/homeIndex"></Header>
    <div class="xkztck_main">
      <NOdata title="暂无选课状态查看数据~" v-if="list.length == 0"></NOdata>
      <mode-list
        v-else
        v-for="(item, index) in list"
        :key="index"
        :item="item"
      ></mode-list>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import modeList from "./modeList.vue";
export default {
  components: { modeList },
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.findXkztcx();
      if (res.code == 1) {
        this.list = res.data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.xkztck {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  overflow: auto;
  .xkztck_main {
    padding: 10px 15px 0;
    .xkztck_item {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkztck/index.vue